// Preserve plain-text errors while displaying structured API errors and support references.
export default async function responseErrorMessage(response) {
  const text = await response.text();
  try {
    const body = JSON.parse(text);
    if (body && typeof body.message === 'string') {
      return body.reference ? `${body.message} (${body.reference})` : body.message;
    }
  } catch (e) { /* Legacy endpoints return plain text. */ }
  return text;
}



// WEBPACK FOOTER //
// ./src/utils/responseErrorMessage.js